import {assertEqual, assertTrue} from "../../unittests/UnitTestHelper";
import {getValidLookupObject} from "./ParsersHelper";
import {parseUrl} from "./ParametersParser";
import {appdata} from "../../logic_tmp/appdata/AppData";
import {lgSetup} from "../../backend/LgSetup";

export function getProductParamsTest() {
    return "productCode=RECORDING-ONEGIN-PART1&lng=ru"
}


export function testProductParamsParser() {
    let str = getProductParamsTest()
    let res = parseUrl({}, str)
    assertEqual("RECORDING-ONEGIN-PART1", res.productCode)
    assertTrue(res.product !== undefined)
    assertEqual("FLEX",res.priceModel)

    str = getProductParamsTest() + "&key2=23A1000A700A2320"
    res = parseUrl({}, str)
    assertEqual("RECORDING-ONEGIN-PART1", res.productCode)
    assertTrue(res.product !== undefined)
    assertEqual("FLEX",res.priceModel)
    assertEqual(10,res.priceFull)
    assertEqual(7,res.priceReduced)
}

export function parseProductParams(params, ret) {
    ret.product = getValidLookupObject("products","productCode",ret,params)
    ret.currency = ret.product.currency
    ret.priceModel = ret.product.priceModel
    ret.key2 = params.key2
    ret.spKeyRedim = params["spKeyRedim"]

}

